export default class EventLog {
    id = 0;
    facilityId = "";
    eventLogEvent = "";
    eventLogType = "";
    text1 = "";
    text2 = "";
    text3 = "";
    referenceId = "";
    creationDate = null;    
    facilityName = "";
    message = ""
    documentations = []
    
    constructor() {
    }
}